import React from 'react';
import { Table } from 'antd';

import { TableCol } from './getTableCol';

import { planStruct } from './struct';


export const Plan = ({ planing }) => {


  const columns = [
    ...TableCol()
  ];

  return (
    <>
      <Table {...planStruct.table} columns={columns} dataSource={planing} />
    </>
  );
};
